import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-progress',
  templateUrl: './progress.component.html',
  styleUrls: ['./progress.component.scss']
})
export class ProgressComponent implements OnInit {
  @Input() progress = 0;

  @Output() cancelUpload = new EventEmitter<any>();
  constructor() {}

  ngOnInit() {}

  cancel() {
    this.cancelUpload.emit()
  }
}
